import { useCustomerId, useDispersions, useURLparams } from '@hooks';
import { FullWidthContent, MainMenuLayout } from '@layouts';
import DispersionsList from './DispersionsList';
import SearchBoxMyDispersions from './modules/SearchBoxMyDispersions';

/** My dispersions screen */
const MyDispersionsScreen = () => {
  const { params, setURLparams } = useURLparams();
  const { customerId } = useCustomerId();
  const { data, isLoading, handleRowsPerPageChange, handlePageChange, handleRefresh } =
    useDispersions(customerId, {
      params,
      setURLparams,
    });

  return (
    <MainMenuLayout>
      <FullWidthContent>
        <SearchBoxMyDispersions isLoading={isLoading} dataLength={data?.page?.length || 0} />
        <DispersionsList
          data={data}
          isLoading={isLoading}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handlePageChange={handlePageChange}
          handleRefresh={handleRefresh}
        />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default MyDispersionsScreen;
